<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
      <v-toolbar-items>
        <v-btn v-if="isAdminUser" flat color="primary" dark slot="activator" @click="dialog = !dialog">
          <v-icon dark>add</v-icon>Add Vendor</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <app-delete-confirmation-dialog :model="deleteDialog" name="Vendor" :didCancel="dismissDeleteDialog" :didDelete="deleteItem"></app-delete-confirmation-dialog>

    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="editedItem.name"
                        label="Vendor Name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td><router-link :to="'/vendors/' + props.item.id+ '/accounts'">{{ props.item.name }}</router-link></td>
          <td>{{ props.item.dateModified | formatDate }}</td>
          <td class="justify-center layout px-0">
            <v-btn
              v-if="!props.item.isApproved"
              class="mx-0 success"
              small
              @click="approve(props.item)"
              :disabled="loading"
              :loading="loading"
            >Approve
            </v-btn>
            <v-btn icon class="mx-0" :to="'/vendors/' + props.item.id +'/accounts'">
              <v-icon color="blue darken-3">person</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="editItem(props.item)">
              <v-icon color="blue darken-3">edit</v-icon>
            </v-btn>
            <v-btn v-if="isAdminUser" icon class="mx-0" @click="confirmDeleteItem(props.item)">
              <v-icon color="red darken-3">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
            You have not added any Vendors
            <v-btn color="primary" @click="dialog = true">Add Vendor</v-btn>
        </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    deleteDialog: false,
    itemToDelete: null,
    headers: [
      { text: 'Organisations', align: 'left', sortable: true, value: 'name' },
      { text: 'Last Modified', value: 'dateModified', sortable: true },
      { text: 'Actions', align: 'centre', value: 'name', sortable: false }
    ],
    editedIndex: -1,
    editedItem: { name: '', dateModified: '' },
    defaultItem: { name: '', dateModified: '' },
    nameRules: [
      v => !!v || 'Vendor name is required'
    ]
  }),

  created () {
    this.$store.dispatch('vendors/list')
  },

  computed: {
    pageTitle () {
      return this.$store.getters.isAdminUser ? 'Vendors' : 'Users'
    },
    loading () {
      return this.$store.getters.loading
    },
    formTitle () {
      if (this.$store.getters.isAdminUser) {
        return this.editedIndex === -1 ? 'New Vendor' : 'Edit Vendor'
      }
      return this.editedIndex === -1 ? 'Invite User' : 'Edit User'
    },
    items () {
      return this.$store.getters['vendors/items']
    },
    isAdminUser () {
      return this.$store.getters.isAdminUser
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {
    viewAccounts (item) {
      this.$router.push({ name: 'vendor', params: { userId: 123 } })
    },

    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    confirmDeleteItem (item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    approve (item) {
      this.$store.dispatch('vendors/approve', item.id)
    },

    deleteItem () {
      this.$store.dispatch('vendors/delete', this.itemToDelete.id)
      this.dismissDeleteDialog()
    },
    dismissDeleteDialog () {
      this.itemToDelete = null
      this.deleteDialog = false
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        this.$store.dispatch('vendors/update', this.editedItem)
      } else {
        this.$store.dispatch('vendors/create', this.editedItem)
      }
      this.close()
    }
  }
}
</script>
